import React from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Textarea } from '../ui/textarea';
import { africanCountries, kenyaData, otherCountriesData } from '../../data/locationData';

const LocationFields = ({
    formData,
    setFormData,
    availableCounties,
    availableSubcounties,
    availableCities,
    disabled = false
}) => {
    return (
        <>
            {/* Country */}
            <div className="space-y-2">
                <Label className="text-xs tracking-widest uppercase text-muted-foreground">Country *</Label>
                <Select
                    value={formData.country}
                    onValueChange={(v) => setFormData({ 
                        ...formData, 
                        country: v, 
                        county: '', 
                        subcounty: '', 
                        city: '' 
                    })}
                    disabled={disabled}
                >
                    <SelectTrigger className="bg-[#0a1628] border-white/10 h-11" data-testid="country-select">
                        <SelectValue placeholder="Select country" />
                    </SelectTrigger>
                    <SelectContent className="bg-[#0d2847] border-white/10 max-h-[300px]">
                        {africanCountries.map((country) => (
                            <SelectItem key={country} value={country}>{country}</SelectItem>
                        ))}
                    </SelectContent>
                </Select>
            </div>

            {/* Kenya-specific: County */}
            {formData.country === 'Kenya' && (
                <div className="space-y-2">
                    <Label className="text-xs tracking-widest uppercase text-muted-foreground">County *</Label>
                    <Select
                        value={formData.county}
                        onValueChange={(v) => setFormData({ 
                            ...formData, 
                            county: v, 
                            subcounty: '', 
                            city: '' 
                        })}
                        disabled={disabled}
                    >
                        <SelectTrigger className="bg-[#0a1628] border-white/10 h-11" data-testid="county-select">
                            <SelectValue placeholder="Select county" />
                        </SelectTrigger>
                        <SelectContent className="bg-[#0d2847] border-white/10 max-h-[300px]">
                            {availableCounties.map((county) => (
                                <SelectItem key={county} value={county}>{county}</SelectItem>
                            ))}
                        </SelectContent>
                    </Select>
                </div>
            )}

            {/* Kenya-specific: Sub-county */}
            {formData.country === 'Kenya' && formData.county && (
                <div className="space-y-2">
                    <Label className="text-xs tracking-widest uppercase text-muted-foreground">Sub-county</Label>
                    <Select
                        value={formData.subcounty}
                        onValueChange={(v) => setFormData({ ...formData, subcounty: v })}
                        disabled={disabled}
                    >
                        <SelectTrigger className="bg-[#0a1628] border-white/10 h-11" data-testid="subcounty-select">
                            <SelectValue placeholder="Select sub-county" />
                        </SelectTrigger>
                        <SelectContent className="bg-[#0d2847] border-white/10 max-h-[300px]">
                            {availableSubcounties.map((sc) => (
                                <SelectItem key={sc} value={sc}>{sc}</SelectItem>
                            ))}
                        </SelectContent>
                    </Select>
                </div>
            )}

            {/* City */}
            <div className="space-y-2">
                <Label className="text-xs tracking-widest uppercase text-muted-foreground">
                    {formData.country === 'Kenya' ? 'City/Town *' : 'City *'}
                </Label>
                <Select
                    value={formData.city}
                    onValueChange={(v) => setFormData({ ...formData, city: v })}
                    disabled={disabled}
                >
                    <SelectTrigger className="bg-[#0a1628] border-white/10 h-11" data-testid="city-select">
                        <SelectValue placeholder="Select city" />
                    </SelectTrigger>
                    <SelectContent className="bg-[#0d2847] border-white/10 max-h-[300px]">
                        {availableCities.map((city) => (
                            <SelectItem key={city} value={city}>{city}</SelectItem>
                        ))}
                    </SelectContent>
                </Select>
            </div>
        </>
    );
};

export default LocationFields;
